// extracted by mini-css-extract-plugin
export default {"region":"Toast_region__6Qopk","toast":"Toast_toast__nd-uy","rise":"Toast_rise__haUpZ"};